/**
 * Base currencies a company can be created with or set to: the currency of
 * each country in `COMPANY_COUNTRIES`, plus USD, EUR and GBP. One list for
 * every admin form, so a new country's currency is added once.
 */
export const COMPANY_CURRENCIES = [
  'EGP',
  'SAR',
  'AED',
  'KWD',
  'BHD',
  'OMR',
  'QAR',
  'JOD',
  'USD',
  'EUR',
  'GBP',
] as const
